import type { EntityRegistry } from '@sites/entity-migrator';
import { isRecord } from '@sites/entity-migrator';

import type { DefaultIndent } from './schemas';
import { DefaultIndentEntitySchema } from './schemas';

export const indentRegistry: EntityRegistry<DefaultIndent> = {
    name: 'indent',
    getEntitySchema: (entity: unknown) => {
        if (!isRecord(entity)) return null;

        const { entityType, entitySubType, version, name } = entity;

        if (entityType === 'widget:indent' && entitySubType === 'default') return DefaultIndentEntitySchema;
        // Pre-versioning spacers carry no version; the widget name is the only proof of kind.
        if (version === undefined && name === 'indent') return DefaultIndentEntitySchema;

        return null;
    },
};
